/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type BhActionNameEnum = (typeof BhActionNameEnum)[keyof typeof BhActionNameEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BhActionNameEnum = {
  add_code: 'add_code',
  close_use_credits: 'close_use_credits',
  unstamp_inactive_user: 'unstamp_inactive_user',
  get_more_codes: 'get_more_codes',
  get_more_credits: 'get_more_credits',
  find_sitters: 'find_sitters',
  rebook_previous_sitter: 'rebook_previous_sitter',
  open_webview: 'open_webview',
  link: 'link',
  open_use_credits: 'open_use_credits',
  open_out_of_credits: 'open_out_of_credits',
  open_expiring_credits: 'open_expiring_credits',
  open_credit_inactivity: 'open_credit_inactivity',
  logout: 'logout',
} as const;
